// axios实例
import instance from './instance'
import { jsonp } from 'vue-jsonp'
// 工具类方法
import { AxiosError } from 'axios'
import { obj2Str, trimObj } from '@/utils/tools'
// import { usbUserIsLoginUser } from '@/utils/usbKey'
// import { sm3Digest } from '@/utils/encrypt'
import message from '@/components/MessageWithClose/MessageWithClose'
// 请求入参data声明
export interface dataType {
    [key: string]: any
}
// 请求入参声明
export interface optionsType {
    domain?: string | undefined,
    method?: string | undefined,
    data?: dataType,
    trimFlag?: boolean | undefined,
    headers?: {
        'User-Application'?: string,
        [key: string]: string | boolean | undefined
    },
    responseType?: string,
    timeout?: number,
    url: string,
}
export interface httpConfType {
    http: any
    jsonp?: any
}

export let http = async function (options: optionsType): Promise<any> {

    let httpObj = {}
    let { method = 'get', data = {}, trimFlag = true, url, headers, responseType, timeout } = options

    // 处理url
    const xsstamp = new Date().getTime()
    const xsrandom = Math.round(Math.random() * 10000)
    // const xscheck = sm3Digest(`###sx###${xsstamp}${xsrandom}`)
    // url = `${url}?${obj2Str(method === 'get' ? { ...data, xsstamp, xsrandom, xscheck } : { xsstamp, xsrandom, xscheck })}`
    url = `${url}?${obj2Str(method === 'get' ? { ...data, xsstamp, xsrandom } : { xsstamp, xsrandom })}`

    // 处理data
    data = trimFlag ? trimObj(data) : data // value去前后空格

    if (/^post$/i.test(method)) {
        // 需要校验usb是否为当前登录用户
        // if (sessionStorage.getItem('postCrypto') == 'true') {
        // 	await usbUserIsLoginUser(async (status, { usbContent, mSoftKey3A, DevicePath }) => {
        // 		if (status) {
        // 			data = await mSoftKey3A.SM2_EncString(JSON.stringify(data), DevicePath)
        // 		}
        // 	}, url)
        // }
    }

    httpObj = { headers, responseType, timeout, method, url, data }

    return new Promise((resolve, reject) => {
        switch (method) {
            case 'jsonp': {
                jsonp(url, data).then((res: any): any => {
                    // console.log('------ [jsonp start] response data ------')
                    console.log(res)
                    // console.log('------ [jsonp end] response data ------')
                    if (res.success || res.code == '0') {
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch((err: Error) => {
                    // console.log('------ [jsonp start] catch err ------')
                    console.log(err)
                    // console.log('------ [jsonp end] catch err ------')
                })
                break
            }
            default: {
                instance(httpObj).then((res: any) => {
                    if (res.success == false && res.message) {
                        // console.log('------ [axios start] response data ------')
                        console.log(res)
                        // console.log('------ [axios end] response data ------')
                        // message.error(res.message)
                    }
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
                break
            }
        }
    }).catch((error: AxiosError | any) => {
        // console.log('------ [axios start] catch err ------')
        console.log(error)
        // console.log('------ [axios end] catch err ------')
        let msg = error.response?.data.message || error.detail
        // if (msg) message.error(msg)
        //登录返回状态400 401 406  声光报警
        if (error.response?.data?.message?.indexOf('登录失败次数超过5次，') >= 0 || error.response?.data?.message?.indexOf('账号被锁定，') >= 0 || error.response?.data?.message?.indexOf('ip不匹配') >= 0) {
            let dom: any = document.getElementById('loginErrorAlarm')
            dom.play().catch(err => { })
        }
        throw new Error()
    })
}